module.exports = __webpack_public_path__ + "img/activation.3207e71c.svg";